//src/app/routes/JournalEntriesRoutes.tsx
import { lazy } from './lazyWithRetry';
import { Route } from 'react-router-dom';
import { suspense } from './utils';

const JournalEntries = lazy(() => import('admin/features/journalEntries'));
const JournalEntryDetails = lazy(
  () => import('admin/features/journalEntries/JournalEntryDetails'),
);
const EditJournalEntry = lazy(
  () => import('admin/features/journalEntries/EditJournalEntry'),
);
const CreateJournalEntry = lazy(
  () => import('admin/features/journalEntries/CreateJournalEntry'),
);

export default function JournalEntriesRoutes() {
  return (
    <>
      <Route path="journal_entries" element={suspense(<JournalEntries />)} />
      <Route
        path="journal_entries/create"
        element={suspense(<CreateJournalEntry />)}
      />
      <Route
        path="journal_entries/:entryId"
        element={suspense(<JournalEntryDetails />)}
      />
      <Route
        path="journal_entries/:entryId/edit"
        element={suspense(<EditJournalEntry />)}
      />
    </>
  );
}
